var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container d-flex flex-center fd-column p-x-1:mo m-y-5"},[_c('client-only',[_c('app-login-as-form',{staticClass:"m-b-2"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }